import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { affiliateRoute } from '.'

const AffiliatePolicy = lazyRouteComponent(
  () => import('../../../pages/profile/affiliate/affiliate-policy'),
)

export const affiliatePolicyRoute = createRoute({
  getParentRoute: () => affiliateRoute,
  path: 'affiliate-policy',
  component: AffiliatePolicy,
})
